module.exports = __webpack_public_path__ + "img/MACHO_12.44a96e6c.jpeg";